var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("app-side-menu", [
    _c(
      "aside",
      { staticClass: "menu", attrs: { slot: "side-menu" }, slot: "side-menu" },
      [
        _c("p", { staticClass: "menu-label" }, [
          _c("span", { staticClass: "title is-6" }, [_vm._v(" Filters ")]),
        ]),
        _c("ul", { staticClass: "menu-list" }, [
          _c("li", [
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.rego,
                      expression: "value.rego",
                    },
                  ],
                  staticClass: "input is-uppercase",
                  attrs: { type: "text", placeholder: "Rego" },
                  domProps: { value: _vm.value.rego },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onFilterClick()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.value, "rego", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.claimNo,
                      expression: "value.claimNo",
                    },
                  ],
                  staticClass: "input is-uppercase",
                  attrs: { type: "text", placeholder: "Claim No." },
                  domProps: { value: _vm.value.claimNo },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onFilterClick()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.value, "claimNo", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
            _c("div", { staticClass: "field" }, [
              _c("div", { staticClass: "control" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.value.quoteNo,
                      expression: "value.quoteNo",
                    },
                  ],
                  staticClass: "input is-uppercase",
                  attrs: { type: "text", placeholder: "Quote No." },
                  domProps: { value: _vm.value.quoteNo },
                  on: {
                    keyup: function ($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onFilterClick()
                    },
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.value, "quoteNo", $event.target.value)
                    },
                  },
                }),
              ]),
            ]),
          ]),
        ]),
        _c("hr"),
        _c("div", { staticClass: "field is-grouped is-pulled-right" }, [
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              {
                staticClass: "button is-primary",
                on: { click: _vm.onFilterClick },
              },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-magnify mdi-18px" }),
                ]),
                _c("span", [_vm._v("Filter")]),
              ]
            ),
          ]),
          _c("div", { staticClass: "control" }, [
            _c(
              "button",
              { staticClass: "button", on: { click: _vm.onResetClick } },
              [
                _c("span", { staticClass: "icon" }, [
                  _c("i", { staticClass: "mdi mdi-refresh mdi-18px" }),
                ]),
                _c("span", [_vm._v("Reset")]),
              ]
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }